<template>
  <div>
    <div v-if="isReadyToDraw" class="ticket myticket">
      <TheHeader :click-back-button-event="returnNativeApp" />

      <TheCouponImage :url="masterCoupon.header_image_url" />

      <div class="ticket-detail">
        <TheCouponNameAndComment />

        <hr />

        <TheCouponCode :code="coupon.code" />

        <hr />
      </div>
      <div class="ticket-footer">
        <div v-if="coupon.external_app_url" class="ticket-btn">
          <button @click="useCoupon(coupon.external_app_url)">
            {{ $t("Coupon.useCoupon") }}
          </button>
        </div>

        <div class="ticket-copyright">
          <span>
            Copyright© Odakyu Electric Railway Co., Ltd. All Rights Reserved
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import nativeHandlerService from "@/services/nativeHandler";
import moment from "@/services/moment";

export default {
  name: "TemplateCouponDetail",
  setup() {
    const store = useStore();
    const isReadyToDraw = ref(false);

    const coupon = computed(() => store.getters["coupon/externalCoupon"]);
    const masterCoupon = computed(() => store.getters["coupon/masterCoupon"]);

    const useCoupon = (url) => {
      const externalUrl =
        coupon.value.code && url.endsWith("code=")
          ? url + coupon.value.code
          : url;

      if (process.env.NODE_ENV == "local") {
        window.open(externalUrl);
      } else {
        nativeHandlerService.useCoupon(externalUrl);
      }
    };

    watchEffect(() => {
      if (coupon.value?.id && masterCoupon.value?.id) {
        isReadyToDraw.value = true;
      }
    });
    return {
      coupon,
      masterCoupon,
      isReadyToDraw,
      useCoupon,
    };
  },
};
</script>
<style scoped lang="scss">
.ticket.myticket {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.ticket-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;

  > button {
    width: 100%;
    height: 48px;
    background: #fdd000;
    border-radius: 4px;
    border: 1px solid #fdd000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #000;
    line-height: 24px;
  }
}

.ticket-copyright {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  color: #bdbdbd;
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 20px;
}

.ticket-footer {
  margin-top: auto;
}
</style>
